import PendienteService from 'src/modules/pendiente/pendienteService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'PENDIENTE_FORM';

const pendienteFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: pendienteFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await PendienteService.find(id);
      }

      dispatch({
        type: pendienteFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: pendienteFormActions.INIT_ERROR,
      });

      getHistory().push('/pendiente');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: pendienteFormActions.CREATE_STARTED,
      });

      await PendienteService.create(values);

      dispatch({
        type: pendienteFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.pendiente.create.success'),
      );

      getHistory().push('/pendiente');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: pendienteFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: pendienteFormActions.UPDATE_STARTED,
      });

      await PendienteService.update(id, values);

      dispatch({
        type: pendienteFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.pendiente.update.success'),
      );

      getHistory().push('/pendiente');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: pendienteFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default pendienteFormActions;
